import { processEnv } from '@utils/config';

/** 总mock开关 */
export const Mock = false;
/** 是否开发环境 */
export const Dev = ['local', 'test'].indexOf(processEnv.hostEnv) !== -1;
